import type { Dictionnaire } from '../type';

export const fil: Dictionnaire['fil'] = {
  erreurs: {
    supprimerLesSiens: '你只能删除自己的帖子',
    pasTaReponse: '这条回复不是你的',
    commentaireVide: '评论为空',
    vide: '发布前先写点什么',
    tropLong: (max: number) => `最多 ${max} 个字符`,
  },
  commun: {
    retirerLike: '取消点赞',
    liker: '点赞',
    likerReponse: '给这条回复点赞',
    retirerSignet: '从收藏中移除',
    enregistrer: '加入我的收藏',
    actionsPost: '帖子操作',
    actionsReponse: '回复操作',
    voirPhoto: '全屏查看照片',
    photoDe: (auteur: string) => `${auteur} 发布的照片`,
    supprimerPostQ: '删除这条帖子？',
    supprimerPost: '删除这条帖子',
    supprimerReponseQ: '删除这条回复？',
    supprimerReponse: '删除这条回复',
    signaler: '举报内容',
    partager: '分享',
    suppressionImpossible: '删除失败。',
    reponses: '回复',
    commenter: '评论',
  },
  signets: {
    onglets: {
      posts: '帖子',
      evenements: '活动',
    },
    titre: '我的收藏',
    aucunPost: '没有收藏的帖子',
    aucunPostAide: '收藏一条帖子或回复，就能在这里找到它。',
    aucuneSortie: '没有收藏的活动',
    aucuneSortieAide: '在活动页面点击收藏图标，方便随时查看。',
    compte: (n: number) => `已收藏 ${n} 条`,
  },
  cloche: {
    verbes: {
      like: '赞了你的帖子',
      commentaire: '回复了你的帖子',
      mention: '在帖子中提到了你',
      signet: '收藏了你的帖子',
    },
    titre: '通知',
    activite: '动态',
    vide: '还没有动态',
    nouvelles: (n: number) => `通知 · ${n} 条新通知`,
  },
  composeur: {
    annulerReponse: '取消回复这条回复',
    ecrire: '写评论…',
    envoyer: '发送',
    reponseA: '回复',
    repondreA: (nom: string) => `回复 ${nom}…`,
  },
  reponse: {
    voirReponses: (n: number) => `查看 ${n} 条回复`,
    repondreA: (nom: string) => `回复 ${nom}`,
  },
  fil: {
    envoiImpossible: '回复发送失败',
    partagerReponse: '分享这条回复',
    vide: '暂无回复',
    videAide: '第一个回复这条评论吧。',
  },
  commentaires: {
    envoiImpossible: '评论发送失败',
    titre: '评论',
    vide: '暂无评论',
    videAide: '第一个回应这条帖子吧。',
  },
  composer: {
    impossible: '发布失败',
    titre: '新帖子',
    publier: '发布',
    lieu: '地点',
    evenement: '活动',
    photoJointe: '帖子附带的照片',
    retirerPhoto: '移除照片',
    visible: '整个服务器可见',
    remplacerPhoto: '更换照片',
    ajouterPhoto: '添加照片',
    ajouterLieu: '添加地点',
    joindreEvenement: '关联活动',
    ajouterCeLieu: '添加这个地点',
    retirerLieu: '移除地点',
    termine: '完成',
    retirer: '移除',
    quelEvenement: '哪个活动？',
    aucunEvenement: '没有即将开始的活动',
    aucunEvenementAide: '可以在“活动”标签页创建一个。',
    quoiDeNeuf: (lieu: string) => `${lieu}有什么新鲜事？`,
    lieuChoisi: (lieu: string) => `地点：${lieu}`,
    evenementChoisi: (titre: string) => `活动：${titre}`,
    ouDans: (lieu: string) => `在${lieu}的哪里？`,
  },
  ecran: {
    vues: {
      pourToi: '为你推荐',
      recent: '最新',
    },
    supprime: '帖子已删除。',
    rechercher: '搜索帖子…',
    rechercherLabel: '搜索动态',
    ecrire: '写帖子',
    masquerQ: '隐藏这条帖子？',
    masquer: '隐藏这条帖子',
    aucunResultat: '没有结果',
    vide: '动态还是空的',
    videAide: '第一个在这个服务器上发起话题吧。',
    premierPost: '发布第一条帖子',
    rienNeCorrespond: (recherche: string) => `这个服务器上没有与“${recherche}”匹配的内容。`,
  },
  mesPosts: {
    titre: '我的帖子',
    voirQuiAAime: '查看谁点了赞',
    jaime: '点赞',
    personne: '还没有人赞这条帖子。',
    vide: '没有帖子',
    videAide: '你发布的帖子会出现在这里。',
    compte: (n: number) => `${n} 条帖子`,
  },
};
